import request from '@/utils/http'

/**
 * 获取产品领域列表
 */
export function getProductDomain() {
  return request({
    url: '/api/shop/product_domain',
    method: 'get'
  })
}

/**
 * 获取采购商入驻信息
 */
export function getProcurementApplyInfo() {
  return request({
    url: '/api/procurement/info',
    method: 'get'
  })
}

/**
 * 获取采购商入驻申请状态
 */
export function getProcurementApplyStatus() {
  return request({
    url: '/api/procurement/apply_status',
    method: 'get'
  })
}

/**
 * 提交采购商入驻申请
 * @param {Object} data 申请数据
 */
export function submitProcurementApply(data) {
  return request({
    url: '/api/procurement/apply',
    method: 'post',
    data
  })
}
